module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.type + '-wrapper ' + (_vm.valuebinder === _vm.value ? 'active' : '') + (_vm.below ? ' below' : '') + (_vm.disabled ? ' disabled' : '') + (_vm.specialClass ? ' ' + _vm.specialClass : ''),
    on: {
      "click": _vm.updateValue
    }
  }, [_c('span', [(_vm.labelPosition === 'before' || _vm.labelPosition === 'left') ? _c('label', {
    class: _vm.labelPosition
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "the-graphics",
    style: (_vm.style)
  }), _vm._v(" "), (_vm.labelPosition === 'after') ? _c('label', {
    class: _vm.labelPosition,
    staticStyle: {
      "display": "block",
      "text-align": "center",
      "margin-top": "2px"
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'right') ? _c('label', {
    class: _vm.labelPosition
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5198fb4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Checkbox.vue
// module id = 973
// module chunks = 0